import React, { FC, useEffect, useRef } from 'react';

import { EvTitle } from '@evinced-private/ui-common';

import { ReleaseNote } from '../../../types/release-notes/ReleaseNote';

import { ReleaseNoteCard } from './ReleaseNoteCard';

import './ContentArea.scss';

const MAIN_CONTENT_HEADING_ID = 'main_content_heading';
export const MAIN_CONTENT_ID = 'main_content';

interface ContentAreaProps {
	title: string;
	releaseNotes: ReleaseNote[];
	isLoading: boolean;
	children?: React.ReactNode;
	isError?: boolean;
}

export const ContentArea: FC<ContentAreaProps> = ({
	title,
	releaseNotes,
	isLoading,
	children,
	isError
}) => {
	const hasFocusedOnLoad = useRef(false);

	useEffect(() => {
		// Focus main content on initial page load when content is ready
		if (!isLoading && !hasFocusedOnLoad.current) {
			hasFocusedOnLoad.current = true;
			requestAnimationFrame(() => {
				const mainContent = document.getElementById(MAIN_CONTENT_ID);
				if (mainContent) {
					mainContent.focus();
				}
			});
		}
	}, [isLoading]);

	return (
		<section
			id={MAIN_CONTENT_ID}
			className="release-notes-content-area"
			tabIndex={-1}
			aria-labelledby={MAIN_CONTENT_HEADING_ID}
		>
			<EvTitle
				id={MAIN_CONTENT_HEADING_ID}
				className="content-title"
				headingLevel={2}
				titleText={title}
			/>
			<ReleaseNoteCard releaseNotes={releaseNotes} isLoading={isLoading} isError={isError} />
			{children}
		</section>
	);
};
